/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".promote-from[_ngcontent-%COMP%]{margin-top:-15px;margin-bottom:10px;background-color:#f6f9fc}"];
export { styles as styles };
